export default __webpack_public_path__ + "static/consultation-background-mask-4c94d2033ee8e3ed153a92e4a05b800f.svg";